var patch = require("./vdom/patch.js")

module.exports = patch



// WEBPACK FOOTER //
// ./node_modules/virtual-dom/patch.js